import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useI18n } from '../../../data/hooks/i18nHooks';
import ZoomableImage from '../../screens/EventMap/common/ZoomableImage';
import EventExhibitorsMapButton from '../common/Toolbar/EventExhibitorsMapButton';
import EventMapButton from '../common/Toolbar/EventMapButton';
import SidePanelToolbar from '../common/Toolbar/SidePanelToolbar';
import SidePanelWrapper from '../SidePanelWrapper';

const EventMap = (props) => {
    const { eventId } = useParams(),
        event = useEvent(eventId),
        { settings, map_url, exhibitors_map_url } = useEvent(eventId) || {},
        i18n = useI18n(eventId),
        dispatch = useDispatch();

    const handleClose = useCallback(() => {
        dispatch(app.actions.ui.sidePanel.showEventMap(false));
    }, []);

    useEffect(() => {
        if (!map_url && !exhibitors_map_url) {
            handleClose();
        } else if (!map_url && exhibitors_map_url) {
            dispatch(app.actions.ui.sidePanel.showFloorplan(true));
        } else {
            return () => handleClose();
        }
    }, [map_url, exhibitors_map_url, handleClose]);

    if (!map_url) return null;

    return (
        <SidePanelWrapper>
            <SidePanelToolbar onClose={handleClose}>
                <SidePanelToolbar>
                    {map_url && exhibitors_map_url ? (
                        <>
                            <EventMapButton event={event} isActive />
                            <EventExhibitorsMapButton event={event} />
                        </>
                    ) : (
                        <div className="title">{i18n['label.map']}</div>
                    )}
                </SidePanelToolbar>
            </SidePanelToolbar>
            <ZoomableImage src={map_url} />
        </SidePanelWrapper>
    );
};

export default EventMap;
